import { useDocumentInstance } from 'bridge';
import { Club } from 'business';

export default function useClub(clubId?: string) : Club | null | undefined {
    const club = useDocumentInstance('clubs', clubId);
    return club;
}
